export const costs = [
  'Information scattered across manuals, datasheets, forums and videos',
  'Guessing instead of diagnosing when a motor or drive fails',
  'Repeated failures because the root cause was never found',
  'Uncertainty when selecting, starting or protecting a motor',
];
